import React from 'react';
import { Checkbox, Form } from 'semantic-ui-react';
import SystemOnlyBadge from '../../../../common/SystemOnlyBadge';

interface CheckboxFieldProps {
  label?: string;
  value?: boolean;
  update: (checked: boolean) => void;
  fieldName: string;
  systemOnly?: boolean;
}

const CheckboxField = ({
  label,
  value,
  update,
  fieldName,
  systemOnly
}: CheckboxFieldProps) => (
  <Form.Field>
    <Checkbox
      checked={value}
      onChange={(_event, data) => update(!!data.checked)}
      label={label}
      id={`${fieldName}Id`}
    />
    {systemOnly && <SystemOnlyBadge />}
  </Form.Field>
);

export default CheckboxField;
